import RetryIcon from "@assets/icons/set.svg";
import { useI18n } from "@core/i18n/i18n";
import styled from "@emotion/styled";
import { colors } from "@ui/style/colors";
import React from "react";

interface ResendCodeButtonProps {
	onClick: () => void;
}

export const ResendCodeButton = ({ onClick }: ResendCodeButtonProps): JSX.Element => {
	const { format } = useI18n();

	return (
		<RetryContainer
			className="p-size-s-bold"
			onClick={event => {
				event.stopPropagation();
				onClick();
			}}
		>
			<div>{format("home.pendingPatientsListing.resendCode.item")}</div>
			<RetryIcon width="16" height="16" />
		</RetryContainer>
	);
};

const RetryContainer = styled.div`
	color: ${colors.primary};
	display: flex;
	place-items: center;
	place-content: center;
	gap: 8px;
	padding-top: 0.5em;
	padding-bottom: 0.5em;
	cursor: pointer;
`;
